import { anonymousClient, authenticatedClient } from './util'
import { HTTP_SUCCESS } from '../helpers/utils/http-status'
import { SubscriptionGift } from '../types'

const fetchGiftCards = async () => {
    return anonymousClient()
        .get(
            `/api/subscription-gift-cards?populate=*`,
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not fetch subscription gift cards`)
            }
            return res
        }).then(res => res.data)
}

const fetchGiftBanners = async () => {
    return anonymousClient()
        .get(
            `/api/subscription-gift-misc?populate=*`,
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not fetch subscription gift banners`)
            }
            return res
        }).then(res => res.data)
}

const createSubscriptionGift = async (subscriptionGift: SubscriptionGift) => {
    return anonymousClient()
        .post(
            `/api/subscription-gifts`,
            subscriptionGift,
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not create subscription gift`)
            }
            return res
        }).then(res => res.data)
}

const setupStripeSubscriptionFromSubscriptionGift = async (code: string, exchangeId?: string) => {
    return authenticatedClient()
        .post(
            `/api/setup-stripe-subscription-from-subscription-gift`,
            {code, exchangeId},
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not create subscription gift`)
            }
            return res
        }).then(res => res.data)
}

const linkMaxAgeGiftToMembership = async (code: string, exchangeId?: string) => {
    return authenticatedClient()
        .post(
            `/api/link-max-age-subscription-gift-to-membership`,
            {code, exchangeId},
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not create subscription gift`)
            }
            return res
        }).then(res => res.data)
}

const setupStripeIntent = async (exchangeId: string) => {
    return authenticatedClient()
        .post(
            `/api/create-stripe-setup-intent`,
            {exchangeId},
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not create subscription gift`)
            }
            return res
        }).then(res => res.data)
}

const updateGiftAndStripePaymentOrderOnSuccess = async (code: string) => {
    return anonymousClient()
        .put(
            `/api/subscription-gift`,
            {code},
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not update subscription gift and stripe payment order`)
            }
            return res
        }).then(res => res.data)
}

const retrieveSubscriptionGift = async (code: string) => {
    return anonymousClient()
        .post(
            `/api/fetch-subscription-gift`,
            {code},
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not update subscription gift and stripe payment order`)
            }
            return res
        }).then(res => res.data)
}

export {
    fetchGiftCards,
    createSubscriptionGift,
    updateGiftAndStripePaymentOrderOnSuccess,
    fetchGiftBanners,
    retrieveSubscriptionGift,
    setupStripeSubscriptionFromSubscriptionGift,
    setupStripeIntent,
    linkMaxAgeGiftToMembership,
}